package com.shmbles.web.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent

val CompanyCardStyle = CssStyle {
    base {
        Modifier
            .opacity(60.percent)
            .transition(Transition.of(property = "opacity", duration = 300.ms))
    }
    hover {
        Modifier.opacity(100.percent)
    }
}
